module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Rouble-b4613c404f9fc4ce9ccbb3ba0eff765c.svg";